/**
 * @generated SignedSource<<34ff879ccfbd70d3f3279c918f0958f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type KPIEditMainDeleteKPIButtonMutation$variables = {
  id: string;
};
export type KPIEditMainDeleteKPIButtonMutation$data = {
  readonly routine: {
    readonly delete: boolean | null;
  } | null;
};
export type KPIEditMainDeleteKPIButtonMutation = {
  response: KPIEditMainDeleteKPIButtonMutation$data;
  variables: KPIEditMainDeleteKPIButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delete",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditMainDeleteKPIButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditMainDeleteKPIButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f965c54f4db49d95f202b715fe753b40",
    "id": null,
    "metadata": {},
    "name": "KPIEditMainDeleteKPIButtonMutation",
    "operationKind": "mutation",
    "text": "mutation KPIEditMainDeleteKPIButtonMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    delete\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed1de17b99c8c31820fbb6ed22da93e0";

export default node;
